import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useConsent } from '../../context';
import { Link as RouterLink } from 'react-router-dom';
import { useT } from '../../i18n/LocaleContext';

export function ConsentPreferencesDialog() {
  const {
    analyticsConsent,
    grantAnalytics,
    denyAnalytics,
    resetAnalytics,
    preferencesOpen,
    setPreferencesOpen,
    closePreferences,
  } = useConsent();
  const t = useT();

  const analyticsEnabled = analyticsConsent === 'granted';

  const handleToggle = (checked) => {
    if (checked) {
      grantAnalytics();
    } else {
      denyAnalytics();
    }
  };

  const handleReset = () => {
    resetAnalytics();
    closePreferences();
  };

  return (
    <Dialog open={preferencesOpen} onOpenChange={setPreferencesOpen}>
      <DialogContent className="max-w-lg w-[calc(100%-2rem)] sm:w-full">
        <DialogHeader className="space-y-1.5 sm:space-y-2">
          <DialogTitle className="text-lg sm:text-xl">{t('consent.dialogTitle')}</DialogTitle>
          <DialogDescription className="text-xs sm:text-sm leading-relaxed">
            <span className="hidden sm:inline">{t('consent.dialogBody')}</span>
            <span className="sm:hidden">{t('consent.dialogBodyShort')}</span>
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 sm:space-y-6">
          <section className="rounded-lg border bg-muted/30 p-3 sm:p-4">
            <div className="flex items-start justify-between gap-3 sm:gap-4">
              <div className="flex-1 min-w-0">
                <Label htmlFor="analytics-toggle" className="text-sm sm:text-base font-medium">{t('consent.analytics')}</Label>
                <p className="mt-1 text-xs sm:text-sm text-muted-foreground leading-relaxed">
                  <span className="hidden sm:inline">{t('consent.analyticsBody')}</span>
                  <span className="sm:hidden">{t('consent.analyticsBodyShort')}</span>
                </p>
              </div>
              <Switch
                id="analytics-toggle"
                checked={analyticsEnabled}
                onCheckedChange={handleToggle}
                aria-label={t('consent.toggle')}
                className="shrink-0"
              />
            </div>
          </section>

          <section className="rounded-lg border bg-muted/30 p-3 sm:p-4 text-xs sm:text-sm text-muted-foreground">
            <p className="leading-relaxed">
              <span className="hidden sm:inline">{t('consent.readMore')} <RouterLink to="/privacy" className="underline">{t('consent.policy')}</RouterLink>. {t('consent.revisit')}</span>
              <span className="sm:hidden"><RouterLink to="/privacy" className="underline">{t('consent.policy')}</RouterLink>. {t('consent.revisitShort')}</span>
            </p>
          </section>
        </div>

        <DialogFooter className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-between mt-3 sm:mt-4">
          <Button type="button" variant="outline" onClick={handleReset} className="w-full sm:w-auto text-sm py-2 sm:py-2.5">
            {t('consent.reset')}
          </Button>
          <Button type="button" onClick={closePreferences} className="w-full sm:w-auto text-sm py-2 sm:py-2.5">
            {t('consent.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}


